import Vue from 'vue';
import {
  Button, Spin, Message, Modal,
} from 'iview';
import 'iview/dist/styles/iview.css';

Vue.component('Button', Button);
Vue.component('Spin', Spin);
Vue.prototype.$Spin = Spin;
Vue.prototype.$Message = Message;
Vue.prototype.$Modal = {};
// 自定义风格弹框
// option.content String|Array
// 其他按照iview文档传
Vue.prototype.$Modal.info = (option) => {
  // eslint-disable-next-line
  const render = h => (
    <div class="global-custom-modal">
      <p class="modal-header">
        <span>{ option.name || '提示' }</span>
        <i class="global-close-icon" onClick={() => {
          Modal.remove();
          if (typeof option.onCancel === 'function') {
            option.onCancel();
          }
        }}>
          ×
        </i>
      </p>
      <div class="modal-content">
        {
          option.contentTitle && <p class="modal-content-title">{ option.contentTitle }</p>
        }
        {
          typeof option.content !== 'string'
            ? option.content.map(val => <p style={option.contenTextStyle} class="modal-content-text">{ val }</p>)
            : <p style={option.contenTextStyle} class="modal-content-text">{ option.content }</p>
        }
      </div>
    </div>
  );

  const config = Object.assign({ render, width: '418' }, option);
  Modal.info(config);
};

Vue.prototype.$Modal.confirm = (option) => {
  // eslint-disable-next-line
  const render = h => (
    <div class="global-custom-modal global-custom-modal-btn-reverse">
      <p class="modal-header">
        <span>{ option.name || '提示' }</span>
        <i class="global-close-icon" onClick={() => {
          Modal.remove();
          if (typeof option.onCancel === 'function') {
            option.onCancel();
          }
        }}>
          ×
        </i>
      </p>
      <div class="modal-content">
        {
          typeof option.content !== 'string'
            ? option.content.map(val => <p class="modal-content-text">{ val }</p>)
            : <p class="modal-content-text">{ option.content }</p>
        }
      </div>
    </div>
  );

  const config = Object.assign({ render, width: '475' }, option);
  Modal.confirm(config);
};
